// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"530":"b2c4f02f","551":"37a06f2e","809":"8caf3855","873":"6d3ee352","955":"c429bb5d"}[chunkId] + ".chunk.js";
};